<div class="container py-5" style="max-width: 520px;">
    <div class="text-center mb-4">
        <h2 class="fw-bold mb-1">Confirm your email</h2>
        <div class="text-muted">Enter the 6-digit code sent to your email</div>
    </div>

    <div *ngIf="error" class="alert alert-danger">{{ error }}</div>
    <div *ngIf="success" class="alert alert-success">{{ success }}</div>

    <form class="card shadow-sm" [formGroup]="form" (ngSubmit)="submit()">
        <div class="card-body p-4">
            <label class="form-label">6-digit verification code</label>
            <input class="form-control" formControlName="pin" inputmode="numeric" maxlength="6" placeholder="123456"
                [class.is-invalid]="submitted && form.controls.pin.invalid" />
            <div class="invalid-feedback">
                Enter a valid 6-digit verification code.
            </div>

            <button class="btn btn-primary w-100 mt-3" type="submit" [disabled]="loading">
                <span *ngIf="!loading">Confirm</span>
                <span *ngIf="loading">Confirming...</span>
            </button>

            <div class="text-center mt-3">
                <a routerLink="/auth/login" class="text-decoration-none">Back to login</a>
            </div>
            <!-- Resend code (link + countdown) -->
            <div class="text-center mt-3">
                <a href="javascript:void(0)" class="text-decoration-none" (click)="resendPin()"
                    [class.disabled]="!canResend()" [attr.aria-disabled]="!canResend()">
                    <span *ngIf="canResend()">Resend code</span>
                    <span *ngIf="!canResend()">Resend in {{ cooldownSeconds }}s</span>
                </a>

                <div *ngIf="resendMessage" class="text-muted small mt-2">
                    {{ resendMessage }}
                </div>
            </div>
        </div>
    </form>
</div>